import axios from 'axios';
import { PullRequest, PullNotification } from '@/interfaces/responses/pull-api';

const PullAPIHelper = {
	async getAvailablePulls(justwatchId: string, payload: PullRequest): Promise<PullNotification[]> {
		const response = await axios
			.post(`${JW_CONFIG.PULL_URL}/pull/${justwatchId}/available`, payload)
			.catch(error => {
				console.error(`[PullAPIHelper] getAvailablePulls`, error.message);
			});
		if (response && response.data) {
			return response.data;
		} else {
			return [];
		}
	},
};

export default PullAPIHelper;
